/**
 * ArtifactOverlay — F12: the artifact "layover".
 *
 * A single app-wide centered modal (mounted once in MultiAgentRoute) that shows
 * the currently-targeted artifact's code FULL-SIZE with a close — opened from any
 * artifact surface via useArtifactOverlayStore.open(). It reuses ArtifactCard's
 * content rendering (code_patch diff, Monaco code, data tables, markdown) with
 * `hideHeader` so the dialog supplies the title + close instead of nested chrome.
 *
 * The DialogContent carries `ma-route` so the multi-agent CSS tokens (--ma-*)
 * resolve inside the Radix portal (which renders at <body>, outside .ma-route).
 */
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogMain,
  DialogTitle,
} from "@ncoder/ui";
import { ArtifactCard } from "@/components/molecules/multi-agent/ArtifactCard";
import { sanitizeArtifactLabel } from "@/services/multi-agent/artifactDisplay";
import { useArtifactOverlayStore } from "@/stores/multiAgentArtifactOverlayStore";

export function ArtifactOverlay() {
  const artifact = useArtifactOverlayStore((s) => s.artifact);
  const close = useArtifactOverlayStore((s) => s.close);

  return (
    <Dialog open={!!artifact} onOpenChange={(o) => { if (!o) close(); }}>
      {artifact ? (
        <DialogContent className="ma-route w-full max-w-[min(96vw,1100px)] gap-2 p-0">
          <DialogHeader className="px-4 pt-4 pb-1">
            <DialogTitle className="truncate pr-8 text-sm font-semibold">
              {sanitizeArtifactLabel(artifact.name, artifact.id.slice(0, 8))}
            </DialogTitle>
          </DialogHeader>
          <DialogMain className="px-4 pb-4">
            <ArtifactCard artifact={artifact} hideHeader defaultOpen hideWorkspaceActions />
          </DialogMain>
        </DialogContent>
      ) : null}
    </Dialog>
  );
}
